import { Divider } from 'antd';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import styles from '../RoomDiscount.module.scss';
import type { DefaultDiscountMode } from '../hooks/useRoomDiscountLogic';

import { DefaultDiscountSection } from './DefaultDiscountSection';
import { LastMinuteDiscountSection } from './LastMinuteDiscountSection';

type RoomDiscountContentProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  discountMode: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  getDayBasePrice: (day: DayOfWeek) => number | null | undefined;
  onDiscountModeChange: (mode: DefaultDiscountMode) => void;
  lastMinuteNightRoomDiscountRate?: number | null;
  isLastMinuteEnabled: boolean;
  onLastMinuteToggle: (value: boolean) => void;
  onDiscountToggle: (value: boolean) => void;
  isDiscountEnabled: boolean;
};

export const RoomDiscountContent = ({
  currencyFormatter,
  formRoomPrice,
  discountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  getDayBasePrice,
  onDiscountModeChange,
  lastMinuteNightRoomDiscountRate,
  isLastMinuteEnabled,
  onLastMinuteToggle,
  onDiscountToggle,
  isDiscountEnabled,
}: RoomDiscountContentProps) => {
  const isLastMinuteDisabled =
    isDiscountEnabled &&
    discountMode === 'CONSTANT' &&
    (defaultNightRoomDiscount === null ||
      defaultNightRoomDiscount === undefined);

  return (
    <div className={styles.discountsList}>
      <DefaultDiscountSection
        currencyFormatter={currencyFormatter}
        formRoomPrice={formRoomPrice}
        discountMode={discountMode}
        defaultNightRoomDiscount={defaultNightRoomDiscount}
        defaultNightRoomDiscountDays={defaultNightRoomDiscountDays}
        getDayBasePrice={getDayBasePrice}
        onDiscountModeChange={onDiscountModeChange}
        isDiscountEnabled={isDiscountEnabled}
        onDiscountToggle={onDiscountToggle}
      />
      <Divider className={styles.divider} plain>
        <div className={styles.dividerText}>and / or</div>
      </Divider>
      <LastMinuteDiscountSection
        currencyFormatter={currencyFormatter}
        formRoomPrice={formRoomPrice}
        disabled={isLastMinuteDisabled}
        lastMinuteNightRoomDiscountRate={lastMinuteNightRoomDiscountRate}
        isLastMinuteEnabled={isLastMinuteEnabled}
        onLastMinuteToggle={onLastMinuteToggle}
      />
    </div>
  );
};
